<!--START: header-->
<landing-app-header></landing-app-header>
<!--END: header-->
<div class="hero-section bg-gray wf-section">
  <div class="container">
    <div class="hero-title-center left">
      <h1 data-w-id="6d7ac3f9-a2b3-c52e-96fc-d93bf49d854f" class="hero-title">
        Bring Your
        <span class="add-scribble-below">Ideas</span> to Life<br>
      </h1>
      <div class="margin-40px">
        <div class="text-block-4">Check out some of sample stores to help get your juices flowing!</div>
      </div>
    </div>
  </div>
</div>
  <img src="assets/img/scribbles-10.png" width="150" data-w-id="4e0368ec-9c78-25b4-e8d1-1b9b7db702cf" sizes="(max-width: 991px) 100px, 150px" srcset="assets/img/scribbles-10-p-500.png 500w, assets/img/scribbles-10.png 800w" alt="" class="scribble-5">
  <img src="assets/img/scribbles-9.png" width="60" data-w-id="eb6c57c2-35df-465b-ddf9-37bbdd2b250d" sizes="100vw" srcset="assets/img/scribbles-9-p-500.png 500w, assets/img/scribbles-9.png 718w" alt="" class="scribble-2">
  <div class="section storesection homepage wf-section">
    <div class="container">
      <div class="carers-grid">
        <div class="carers-photo photo-2">
          <img src="assets/img/scribbles-8.png" width="100" data-w-id="cb98e558-db43-585b-2251-8c6d081e1650" sizes="(max-width: 479px) 50px, 100px" srcset="assets/img/scribbles-8-p-500.png 500w, assets/img/scribbles-8-p-800.png 800w, assets/img/scribbles-8-p-1080.png 1080w, assets/img/scribbles-8-p-1600.png 1600w, assets/img/scribbles-8.png 2287w" alt="" class="scribble-6">
          <div class="flex-content">
            <div class="margin-20px">
              <h2 class="hero-title _50px color-white">Fundraising Stores<br></h2>
            </div>
            <div class="margin-20px">
              <p class="sub-heading color-white">Get the most out of your fundraising by using a made to order store where you can sell as much your cause needs with no up front costs. <strong><br></strong></p>
            </div>
          </div>
          <a (click)="openloginFormDialog()" class="button orange w-button">View Live Store→</a>
        </div>
        <div class="carers-block merch-store">
          <div class="flex-content">
            <div class="margin-20px">
              <h2 class="hero-title _50px color-white">Pop Up Merch Stores<br></h2>
            </div>
            <div class="margin-20px">
              <p class="sub-heading color-white">Your best work happens when tools stay out of the way.<strong><br></strong></p>
            </div>
          </div>
          <div class="margin-20px">
            <a (click)="openloginFormDialog()" class="button orange w-button">View Live Store→</a>
          </div>
        </div>
      </div>
      <div class="margin-50px">
        <div class="carers-grid">
          <div class="carers-block orange">
            <div class="flex-content">
              <div class="margin-20px">
                <h2 class="hero-title _50px color-white">Small Business Stores<br></h2>
              </div>
              <div class="margin-20px">
                <p class="sub-heading color-white">For a simple company store, check out this sample store to see what you can create for your small business.<strong><br></strong></p>
              </div>
            </div>
            <div class="margin-20px">
              <a (click)="openloginFormDialog()" class="button orange w-button">View Live Store→</a>
            </div>
          </div>

          <div class="carers-block orange">
            <div class="flex-content">
              <div class="margin-20px">
                <h2 class="hero-title _50px color-white">School Stores<br></h2>
              </div>
              <div class="margin-20px">
                <p class="sub-heading color-white">This is a great sample store if you are looking to build a quick and simple store for you school club, booster club or athletic fundraiser.<strong><br></strong></p>
              </div>
            </div>
            <div class="margin-20px">
              <a (click)="openloginFormDialog()" class="button team-store w-button">View Live Store→</a>
            </div>
          </div>
          <div class="carers-block orange">
            <div class="flex-content">
              <div class="margin-20px">
                <h2 class="hero-title _50px color-white">Shopify Merch store<br></h2>
              </div>
              <div class="margin-20px">
                <p class="sub-heading color-white">For more advanced and established clothing companies should look to integrate our Shopify App and now you will be able to sell your merch to order.<strong><br></strong></p>
              </div>
            </div>
            <div class="margin-20px">
              <a (click)="openloginFormDialog()" class="button team-store w-button">View Live Store→</a>
            </div>
          </div>
          <div class="carers-block orange">
            <div class="flex-content">
              <div class="margin-20px">
                <h2 class="hero-title _50px color-white">Shopify Company store<br></h2>
              </div>
              <div class="margin-20px">
                <p class="sub-heading color-white">Companies with larger workforces and more products to distribute to their staff should contact us to build a Shopify store where we can integrate all our made to order products to reduce your up front and overall company apparel. <strong><br></strong></p>
              </div>
            </div>
            <div class="margin-20px">
              <a (click)="openloginFormDialog()"class="button team-store w-button">View Live Store→</a>
            </div>
          </div>
          <div class="carers-block orange">
            <div class="flex-content">
              <div class="margin-20px">
                <h2 class="hero-title _50px color-white">Shopify Influencer store<br></h2>
              </div>
              <div class="margin-20px">
                <p class="sub-heading color-white">To help monetize your following, you should contact us about building a Shopify store where we can sell your merchandise made to order to maximize your speed to market and reduce your costs associated with building a merch line.<strong><br></strong></p>
              </div>
            </div>
            <div class="margin-20px">
              <a (click)="openloginFormDialog()" class="button team-store w-button">View Live Store→</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--START: Footer-->
  <landing-app-footer></landing-app-footer>
  <!--END: Footer-->
